/**
 * ChatContext
 * Tracks which order's chat is currently open
 * Used to suppress toast notifications when user is viewing the conversation
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ChatContextType {
  openChatOrderId: number | null;
  setOpenChatOrderId: (orderId: number | null) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};

interface ChatProviderProps {
  children: ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [openChatOrderId, setOpenChatOrderId] = useState<number | null>(null);

  return (
    <ChatContext.Provider value={{ openChatOrderId, setOpenChatOrderId }}>
      {children}
    </ChatContext.Provider>
  );
};

